module.exports = __webpack_public_path__ + "img/square_rotation_af.13da0bfd.svg";